module.exports = __webpack_public_path__ + "static/animated-hand-b74b9efc0db22b327bcaeca9ed96a433.gif";